//@ts-check
class CScroll extends HTMLElement {
  constructor() {
    super()
    this.header = document.querySelector('.container-header')
    this.lastScrollY = undefined
    this.isHeaderTransparent = this.header?.classList.contains('v-transparent')
    this.btnStickyProduct = document.querySelector(
      '.section-btn-sticky:has(.product-btn-sticky.v-desktop)'
    )
  }

  connectedCallback() {
    if (this.lastScrollY === undefined) {
      this.lastScrollY = window.scrollY
    }
    if (this.lastScrollY < 100 && this.isHeaderTransparent) {
      this.header?.classList.remove('is-white')
    } else {
      this.header?.classList.add('is-white')
    }
    window.addEventListener('scroll', this.handleScroll.bind(this))
  }
  handleScroll() {
    if (document.documentElement.classList.contains('is-overflow-hidden')) {
      return
    }
    if (this.lastScrollY === undefined) {
      this.lastScrollY = window.scrollY
    }
    const isScrollingDown = window.scrollY > this.lastScrollY
    const isAtTop = window.scrollY <= 1
    if (this.lastScrollY < 100 && this.isHeaderTransparent) {
      this.header?.classList.remove('is-white')
    } else {
      this.header?.classList.add('is-white')
    }

    // Always show header when at top of page
    if (isAtTop) {
      this.header?.classList.remove('is-scroll-down')
      this.btnStickyProduct?.classList.remove('is-scroll-down')
    } else if (isScrollingDown) {
      this.header?.classList.add('is-scroll-down')
      this.btnStickyProduct?.classList.add('is-scroll-down')
      document.documentElement.style.setProperty('--header-height', `${0}px`)
    } else {
      this.header?.classList.remove('is-scroll-down')
      this.btnStickyProduct?.classList.remove('is-scroll-down')
      document.documentElement.style.setProperty('--header-height', `${90}px`)
    }
    this.lastScrollY = window.scrollY
  }
  disconnectedCallback() {
    window.removeEventListener('scroll', this.handleScroll.bind(this))
  }
}
if (!customElements.get('c-scroll')) {
  customElements.define('c-scroll', CScroll)
}
